// Install before BrowserRouter registers its history listener. A rejected POP and
// its compensating POP never reach React Router, so the mounted draft stays intact.
let guard: (() => boolean) | null = null;
let index =
  typeof window === "undefined" ? 0 : (window.history.state?.idx ?? 0);
let reverting = false;
if (typeof window !== "undefined")
  window.addEventListener(
    "popstate",
    (event) => {
      const next = event.state?.idx ?? index;
      if (reverting) {
        event.stopImmediatePropagation();
        reverting = false;
        index = next;
        return;
      }
      if (guard && !guard()) {
        event.stopImmediatePropagation();
        if (next !== index) {
          reverting = true;
          window.history.go(index - next);
        }
        return;
      }
      index = next;
    },
    true,
  );
export function setKnowledgeNavigationGuard(next: (() => boolean) | null) {
  guard = next;
  index = window.history.state?.idx ?? 0;
}
export function recordKnowledgeHistoryIndex() {
  index = window.history.state?.idx ?? index;
}
